import classNames from "classnames";
import React from "react";
import { twMerge } from "tailwind-merge";
import { PiUploadSimpleBold } from "react-icons/pi";

const FileUpload = ({
  label,
  placeholder,
  id,
  containerClasses,
  error,
  isDisabled,
  className,
  accept,
  onChange,
  required,
}) => {
  return (
    <div className={classNames(twMerge("mb-4", containerClasses))}>
      <label htmlFor={id} className="block mb-2 text-[0.9rem]">
        {label} {required && <sup className="text-red-500">*</sup>}
      </label>
      <label
        htmlFor={id}
        className={twMerge(
          "w-full p-2 border-dashed border-2 border-primary/30 rounded-md outline-none flex items-center gap-2 text-primary cursor-pointer",
          error && "border-red-500 focus:border-red-500",
          isDisabled && "bg-stroke border-stroke",
          className
        )}
      >
        <PiUploadSimpleBold className="text-lg" />
        <span className="font-semibold text-sm">{placeholder}</span>
      </label>
      {error && (
        <small className="text-red-500 text-sm block my-1">{error}</small>
      )}
      <input
        type="file"
        id={id}
        className="hidden"
        disabled={isDisabled}
        accept={accept}
        onChange={onChange}
        multiple
      />
    </div>
  );
};

export default FileUpload;
